import React from "react";
import Header from "../components/Header/Header";
import BottomNav from "../components/BottomNav/BottomNav";
import { getBrandName } from "../common/brand";
export default function AboutUs() {
  const brandName = getBrandName();
  return (
    <>
    <Header />
      <div className="ab-page">
        <div className="ab-container">
          <div className="ab-faq">
            <p className="ab-main-highlight">
              <strong>
                {brandName} is one of Bangladesh’s most advanced and world-class
                online gaming and sports exchange platforms
              </strong>
            </p>

            <p className="ab-space">&nbsp;</p>

            <p className="ab-title">
              <em>
                <strong>About us</strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>
                  We are committed to providing players with a safe, fast, and
                  seamless online betting experience. From sports betting,
                  cricket exchange, live casino, slots, and arcade games—you’ll
                  find a wide range of exciting options, all fully
                  mobile-friendly and accessible 24/7.
                </strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>
                  {brandName} was established with a clear mission—to create a
                  trusted, transparent, and internationally standard gaming
                  experience for players in Bangladesh. Ensuring user security,
                  privacy, and fast payment processing is our top priority.
                </strong>
              </em>
            </p>

            <div className="ab-divider">________________________________________</div>

            <p className="ab-section-title">
              <em>
                <strong>What Makes Us Special</strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>⭐ Fast Deposit &amp; Instant Withdrawal</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  We provide one of the quickest and most secure payment systems
                  in Bangladesh—allowing deposits and withdrawals to be
                  completed within minutes.
                </strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>⭐ 24/7 Live Support</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  Our professional support team is always available to assist
                  you with any questions or issues. We aim to ensure the best
                  user experience at all times.
                </strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>⭐ Safe &amp; Trusted Platform</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  We use advanced data security systems, SSL encryption, and
                  robust servers to guarantee maximum protection of your account
                  and financial transactions.
                </strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>⭐ Extensive Game Collection</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  From live dealer casino games to cricket betting, football,
                  slots, Aviator, Mines, and many more—all available under one
                  single platform.
                </strong>
              </em>
            </p>

            <p className="ab-paragraph">
              <em>
                <strong>⭐ Attractive Bonuses &amp; Promotions</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  Both new and existing users enjoy regular bonuses, cashback,
                  free spins, and exclusive VIP rewards.
                </strong>
              </em>
            </p>

            <div className="ab-divider">________________________________________</div>

            <p className="ab-section-title">
              <em>
                <strong>Our Vision</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  To modernize and elevate the online gaming industry in
                  Bangladesh by promoting a safe, responsible, and world-class
                  gaming culture.
                </strong>
              </em>
            </p>

            <p className="ab-section-title">
              <em>
                <strong>Our Mission</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>• Deliver the fastest payment and support experience</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>• Build the most secure gaming platform</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  • Continuously add new games and features based on player
                  interest
                </strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  • Ensure a transparent and responsible betting environment
                </strong>
              </em>
            </p>

            <div className="ab-divider">________________________________________</div>

            <p className="ab-section-title">
              <em>
                <strong>Why Choose {brandName}?</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>✔ 100% Bangladesh-friendly</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>✔ Smooth gameplay on both mobile &amp; PC</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>✔ VIP program and daily bonuses</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>✔ Trusted and responsive support</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>✔ Safe, transparent, and reliable service</strong>
              </em>
            </p>

            <div className="ab-divider">________________________________________</div>

            <p className="ab-section-title">
              <em>
                <strong>{brandName} – Your Trusted Gaming Partner in Bangladesh</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>We believe your trust is our greatest strength.</strong>
              </em>
            </p>
            <p className="ab-paragraph">
              <em>
                <strong>
                  With {brandName}, gaming becomes faster, easier, safer, and more
                  thrilling.
                </strong>
              </em>
            </p>
          </div>
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
        }

        .ab-page {
          min-height: 100vh;
          width: 100%;
          background: #070721;
          padding: 0;
        }

        .ab-container {
          width: 100%;
          max-width: 100%;
        }

        .ab-faq {
          padding: 14px 18px 28px;
        }

        .ab-main-highlight {
          margin: 0;
          color: #ff00ff;
          font-size: 18px;
          line-height: 1.35;
          font-weight: 700;
        }

        .ab-space {
          margin: 0 0 14px;
        }

        .ab-title {
          margin: 0 0 8px;
          color: #ffffff;
          font-size: 16px;
          line-height: 1.6;
          font-weight: 700;
        }

        .ab-section-title {
          margin: 0 0 8px;
          color: #ffffff;
          font-size: 16px;
          line-height: 1.6;
          font-weight: 700;
        }

        .ab-paragraph {
          margin: 0 0 6px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 600;
          word-break: break-word;
        }

        .ab-divider {
          margin: 10px 0 10px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.3;
          letter-spacing: 0.3px;
          white-space: nowrap;
          overflow: hidden;
        }

        @media (max-width: 640px) {
          .ab-faq {
            padding: 12px 16px 24px;
          }

          .ab-main-highlight {
            font-size: 16px;
            line-height: 1.4;
          }

          .ab-title,
          .ab-section-title {
            font-size: 15px;
          }

          .ab-paragraph,
          .ab-divider {
            font-size: 14px;
          }

          .ab-paragraph {
            line-height: 1.65;
          }
        }
      `}</style>
      <BottomNav />
    </>
  );
}